import { EmployerFacilityValues } from './types';

export const emptyEmployerFacilityForm: EmployerFacilityValues = {
  facilityName: { label: '', value: '' },
  facilityNpi: '',
  clinicalSettingCategory: { label: '', value: '' },
  clinicalSetting: { label: '', value: '' },
  facilitySize: { label: '', value: '' },
  areaType: { label: '', value: '' },
  facilityId: '',
};

export type ClinicalSettingCategory = keyof typeof CLINICAL_SETTING_OPTIONS;

const CLINICAL_SETTING_CATEGORY = [
  'Acute Care',
  'Emergency & Urgent Care',
  'Ambulatory / Outpatient Care',
  'Diagnostic & Treatment Centers',
  'Mental Health & Behavioral Services',
  "Women's & Reproductive Health",
  'Post-Acute / Long-Term Care',
  'Home & Community-Based Services',
  'Occupational & Specialized Population Services',
  'Government & Military Healthcare',
  'Telehealth & Virtual Care',
] as const;

export const CLINICAL_SETTING_CATEGORY_OPTIONS: {
  label: ClinicalSettingCategory;
  value: ClinicalSettingCategory;
}[] = CLINICAL_SETTING_CATEGORY.map((category) => ({
  label: category,
  value: category,
}));

export const CLINICAL_SETTING_OPTIONS = {
  'Acute Care': [
    'Large Urban Tertiary or Academic Medical Centers',
    'General Community Hospitals',
    'Critical Access Hospitals',
    'Specialty Hospitals',
    'Long-Term Acute Care Hospitals',
    'Psychiatric Hospitals',
    "Children's/Pediatric Hospitals",
  ].map((item) => ({ label: item, value: item })),
  'Emergency & Urgent Care': [
    'Hospital-Based Emergency Departments',
    'Freestanding Emergency Departments',
    'Urgent Care Centers',
    'Retail/Convenience Care Clinics',
  ].map((item) => ({ label: item, value: item })),
  'Ambulatory / Outpatient Care': [
    'Ambulatory Surgery Centers',
    'Primary Care Clinics',
    'Specialty Clinics',
    'Multi-Specialty Group Practices',
    'Federally Qualified Health Centers',
    'Community Health Centers',
    'Rural Health Clinics',
  ].map((item) => ({ label: item, value: item })),
  'Diagnostic & Treatment Centers': [
    'Imaging/Radiology Centers',
    'Laboratory Services',
    'Dialysis Centers',
    'Infusion Centers',
    'Sleep Centers',
    'Pain Management Centers',
    'Wound Care Centers',
    'Cancer Treatment/Oncology Centers',
  ].map((item) => ({ label: item, value: item })),
  'Mental Health & Behavioral Services': [
    'Behavioral Health Crisis Centers',
    'Mental Health Outpatient Centers',
    'Substance Abuse Treatment Centers',
    'Partial Hospitalization Programs',
  ].map((item) => ({ label: item, value: item })),
  "Women's & Reproductive Health": [
    'Birth Centers',
    "Women's Health Clinics",
    'Family Planning Centers',
  ].map((item) => ({ label: item, value: item })),
  'Post-Acute / Long-Term Care': [
    'Skilled Nursing Facilities',
    'Inpatient Rehabilitation Facilities',
    'Nursing Homes/Long-Term Care Facilities',
    'Assisted Living Facilities',
    'Hospice Facilities',
  ].map((item) => ({ label: item, value: item })),
  'Home & Community-Based Services': [
    'Home Health Agencies',
    'Adult Day Care Centers',
    'Pediatric Day Care Centers',
    'Mobile Health Clinics',
  ].map((item) => ({ label: item, value: item })),
  'Occupational & Specialized Population Services': [
    'Occupational Health/Employee Health Clinics',
    'School-Based Health Centers',
    'Correctional Healthcare Facilities',
  ].map((item) => ({ label: item, value: item })),
  'Government & Military Healthcare': [
    'Veterans Affairs Medical Centers',
    'Military Treatment Facilities',
    'Indian Health Service Facilities',
  ].map((item) => ({ label: item, value: item })),
  'Telehealth & Virtual Care': [
    'Telehealth Platforms/Virtual Care Providers',
    'Remote Patient Monitoring Services',
  ].map((item) => ({ label: item, value: item })),
};

export const FACILITY_SIZE_OPTIONS = [
  { label: 'Small', value: 'Small' },
  { label: 'Medium', value: 'Medium' },
  { label: 'Large', value: 'Large' },
];

export const AREA_TYPE_OPTIONS = [
  { label: 'Urban', value: 'Urban' },
  { label: 'Suburban', value: 'Suburban' },
  { label: 'Rural', value: 'Rural' },
];
